import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { TooltipHost } from '@bingads-webui-react/fabric-control';

export const ConditionalTooltipHost = ({
  condition,
  children,
  maximizeWidth,
  ...restProps
}) => {
  if (condition) {
    const styles = {
      root: _.extend({
        display: 'inline-block',

      }, maximizeWidth && {
        width: '100%',
      }),
    };

    return (
      <TooltipHost
        styles={styles}
        {...restProps}
      >
        {children}
      </TooltipHost>
    );
  }

  return children;
};

ConditionalTooltipHost.propTypes = {
  condition: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  maximizeWidth: PropTypes.bool,
};

ConditionalTooltipHost.defaultProps = {
  maximizeWidth: false,
};
